import ServicePreviewCard from './ServicePreviewCard';
import { ServiceId } from './serviceDefinitions';

type MoveOutServiceCardProps = {
  onSelect: (serviceId: ServiceId) => void;
};

export default function MoveOutServiceCard({
  onSelect,
}: MoveOutServiceCardProps) {
  return <ServicePreviewCard serviceId='move_out_clean' onSelect={onSelect} />;
}
